import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=875963a2&"
import script from "./FormFooter.vue?vue&type=script&lang=js&"
export * from "./FormFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('875963a2')) {
      api.createRecord('875963a2', component.options)
    } else {
      api.reload('875963a2', component.options)
    }
    module.hot.accept("./FormFooter.vue?vue&type=template&id=875963a2&", function () {
      api.rerender('875963a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormFooter.vue"
export default component.exports